import React from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";
import EnergyCard from "./EnergyCard"; // Import the outsourced EnergyCard component

const EnergyCardsContainer = ({ recommendations, onFindOutMore }) => {
  // Fallback for undefined/null recommendations or an empty array
  const hasRecommendations =
    Array.isArray(recommendations) && recommendations.length > 0;

  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      spacing={2}
      justifyContent="center"
      alignItems="center"
      sx={{
        width: "100%",
        overflow: "hidden",
        paddingLeft: { xs: 0, md: 3 },
        paddingRight: { xs: 2, md: 3 },
      }}
    >
      {hasRecommendations ? (
        <Grid
          container
          spacing={2}
          justifyContent="center"
          sx={{
            maxWidth: "1200px", // Maximum width of the entire grid container
            width: "100%",
          }}
        >
          {recommendations.map((recommendation, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center", // Center each card horizontally
                }}
              >
                {/* Spread properties from the SolarSetupDetails class */}
                <EnergyCard
                  {...recommendation}
                  onClick={() => onFindOutMore(recommendation)}
                />
              </Box>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Typography
          variant="h6"
          sx={{ textAlign: "center", color: "gray", marginTop: 4 }}
        >
          No recommendations available.
        </Typography>
      )}
    </Stack>
  );
};

export default EnergyCardsContainer;
